<template>
  <div>
    <component :is="layout">
        <slot />
    </component>
  </div>

</template>

<script setup lang="ts">
import { ref, markRaw, watch, onMounted } from "vue";
import { useCommonStore } from "@/stores/common";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import EmptyLayout from "@/layouts/EmptyLayout.vue";
import type { Component } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const commonStore = useCommonStore();
const layout = ref<Component>(markRaw(EmptyLayout));
const transitionCount = ref(0);

watch(
  () => transitionCount.value,
  (n) => {
    if (n % 2 === 0) {
      commonStore.setTransitionStatus(false);
    } else {
      commonStore.setTransitionStatus(true);
    }
  }
);

// Route watcher
watch(
  () => route.meta?.layout as string | undefined,
  async (newLayout) => {
    if (newLayout) {
      try {
        const component = await import(`../layouts/${newLayout}.vue`);
        layout.value = markRaw(component?.default || DefaultLayout);
        commonStore.setLayout(newLayout);
      } catch (e) {
        layout.value = markRaw(DefaultLayout);
      }
    }
  },
  { immediate: true }
);

const enter = (el: any) => {
  transitionCount.value++;
};

const leave = (el: any) => {
  transitionCount.value++;
};
</script>